function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgExpertSecondOpinion = function SvgExpertSecondOpinion(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M14.667 15.833h2.916v.834h-3.75v-3.75h.834v2.916ZM6.692 4.527a6.667 6.667 0 0 0 5.8 11.834l.25.795A7.5 7.5 0 0 1 6.216 3.843l.476.684Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M14.308 15.472A6.666 6.666 0 0 0 8.507 3.638l-.25-.795a7.5 7.5 0 0 1 6.527 13.313l-.476-.684ZM6.333 4.167H3.417v-.834h3.75v3.75h-.834V4.167Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.accentFillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.593,
    d: "M8.967 7.415h2.767M9.56 11.763h1.581m-.79.79v-1.58m1.185-1.513a2.767 2.767 0 0 1 1.582 2.5v.791a.79.79 0 0 1-.791.79H8.374a.79.79 0 0 1-.79-.79v-.79c0-1.104.646-2.057 1.58-2.501m1.187.326c-.765 0-1.384-.62-1.384-1.383v-1.78a.79.79 0 0 1 .79-.79h1.187a.79.79 0 0 1 .79.79v1.78c0 .764-.62 1.383-1.383 1.383Z"
  }));
};
export default SvgExpertSecondOpinion;